import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import useLocalization from '../../../hooks/useLocalization';
import { useKapopay } from '../../../hooks/payment/useKapopay';
import StyledForm from '../shared/StyledForm';
import FormNumberInput from '../../molecules/form-elements/FormNumberInput';
import FormTextField from '../../molecules/form-elements/FormTextField';
import { requiredNumber } from '../../../utils/validation';
import { createBankTransferSchema } from '../../../schemas/bankTransferSchema';

const defaultValues = {
  amount: undefined,
  beneficiaryName: '',
  IBAN: '',
  swiftCode: '',
  bankName: '',
};

const KapopayWithdrawForm = () => {
  const { t } = useLocalization();
  const {
    withdrawMutation: { mutate: withdraw, isPending },
  } = useKapopay();

  const schema = z.intersection(
    z.object({
      amount: requiredNumber(t),
    }),
    createBankTransferSchema(t)
  );

  type FormInput = z.input<typeof schema>;
  type FormData = z.output<typeof schema>;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput, unknown, FormData>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  const onSubmit = (data: FormData) => {
    withdraw(data);
  };

  return (
    <StyledForm submitTitle={t('continue')} onSubmit={handleSubmit(onSubmit)} isSubmitting={isPending} disablePadding>
      <FormTextField
        control={control}
        name='beneficiaryName'
        label={t('beneficiaryName')}
        error={!!errors.beneficiaryName}
        helperText={errors.beneficiaryName?.message}
      />
      <FormTextField
        control={control}
        name='IBAN'
        label={t('iban')}
        error={!!errors.IBAN}
        helperText={errors.IBAN?.message}
      />
      <FormTextField
        control={control}
        name='swiftCode'
        label={t('swiftCode')}
        error={!!errors.swiftCode}
        helperText={errors.swiftCode?.message}
      />
      <FormTextField
        control={control}
        name='bankName'
        label={t('bankName')}
        error={!!errors.bankName}
        helperText={errors.bankName?.message}
      />
      <FormNumberInput
        control={control}
        name='amount'
        label={t('amount')}
        error={!!errors.amount}
        helperText={errors.amount?.message}
      />
    </StyledForm>
  );
};

export default KapopayWithdrawForm;
